module.exports = __webpack_public_path__ + "img/sightline-display.e2eb18c4.png";